export const limitAfterOpen = (state, maxVisibleToasts) => {
    const orderedToasts = Array.from(state.displayOrder, (id) => state.toasts.get(id)).filter((toast) => toast != null);
    const visibleCount = orderedToasts.filter((toast) => !toast.ending && !toast.limited).length;
    if (visibleCount <= maxVisibleToasts) {
        return state;
    }
    const oldestVisible = orderedToasts.find((toast) => !toast.ending && !toast.limited);
    if (oldestVisible == null) {
        return state;
    }
    const updatedToasts = new Map(state.toasts);
    updatedToasts.set(oldestVisible.id, {
        ...oldestVisible,
        limited: true,
    });
    return {
        ...state,
        toasts: updatedToasts,
    };
};
//# sourceMappingURL=limitAfterOpen.js.map